import { NgModule } from '@angular/core';

import { SharedModule }                   from '../../app-lite/shared/shared.module';
import { VehicleVisualsActionsComponent } from './templates/vehicle-visuals.actions.component';

@NgModule({
  declarations: [
    VehicleVisualsActionsComponent
  ],
  entryComponents: [
    VehicleVisualsActionsComponent
  ],
  imports: [
    SharedModule
  ]
})
export class VehicleVisualsModule {}
